<template>
  <el-image
    class="c-table_image"
    :src="urls[0] || ''"
    :fit="fit"
    ref="image"
    :preview-src-list="isPreview ? urls : []"
    @load="
      () => {
        $emit('on-load');
      }
    "
  >
    <template #placeholder>
      <div class="image-slot">加载中<span class="dot">...</span></div>
    </template>
    <template #error>
      <div class="image-slot" v-if="isShowImageError">
        <i class="el-icon-picture-outline"></i>
      </div>
      <!-- TODO 需要占个位， 不然显示默认的 -->
      <div v-else></div>
    </template>
  </el-image>
</template>

<script>
export default {
  name: "CustomImage",
  props: {
    url: {
      type: String,
      required: true,
      default: "",
    },
    fit: {
      type: String,
      default: "contain",
    },
    isPreview: {
      type: Boolean,
      default: true,
    },
    borderRadius: {
      type: [String],
      default: "0",
    },
    isShowImageError: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      urls: [],
      transform: {
        scale: 1,
        offsetX: 0,
        offsetY: 0,
        enableTransition: false,
      },
    };
  },
  created() {
    this.onInit();
  },
  methods: {
    onInit() {
      if (/(http|https):\/\/([\w.]+\/?)\S*/.test(this.url)) {
        this.urls = this.url ? this.url.split(",") : [];
      } else {
        this.urls = [this.url];
      }
    },
  },
  watch: {
    url: {
      handler: function (n) {
        this.onInit(n);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.c-table_image {
  user-select: none;
  .image-slot {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f7fa;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #5c6075;
    .el-icon-picture-outline {
      font-size: 18px;
    }
  }
}
</style>